import AnnualEventFundraiser from '../../../components/AnnualEventFundraiser';
import React, {Component} from 'react'
import Meta from "../Meta";
import Header from "../header";
import {Button, Card, Col, Result, Row} from "antd";
import CardDon from "./CardDon";
import {ASSET_URL} from "../../../config";
import Footer from "../footer";
import {Carousel} from "react-responsive-carousel";
import {applyI18n, applyLang} from "../../../i18n/index";
import Loader from "../loader";
import MultiDevise from "../../../components/MultiDevise";
import AiContentSlot from "../../../components/AiContentSlot";
import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import logger from "../../../services/logger"

export default class Don extends Component {

    state = {
        client: false
    }

    resizeContent() {
        if (!this.contentText) {
            return null
        }
        try {
            var height = this.contentText.contentWindow.document.body.offsetHeight
            this.contentText.style.height = height + 50 + "px"
        } catch (e) {}
    }

    componentDidMount() {
        this.listener = setInterval(() => this.resizeContent(), 100)
        this.resizeContent()
        this.forceUpdate()
        this.setState({client: true})
    }

    componentWillUnmount() {
        clearInterval(this.listener)
    }

    getCaisse(id) {
        const context = this.props.context
        const {org, config} = context

        return org.caisses.find(i => i.id === id)
    }

    render() {
        if (this.props.loading) {
            return (
                <div>
                    <Loader/>
                </div>
            )
        }

        const context = this.props.context
        const {org, config} = context

        var title = t`Don pour ${org.name}`
        var description = t`Faire un don spontané à ${org.name} sur Kehila.io`

        var youtube = config["page.don.youtube"]
        var bgImage = config["page.don.bg.image"]
        var content = config["page.don.content"]
        var carousel = config["page.don.carousel"]

        let metaTitle = title
        let metaDescription = description
        let metaImage = null

        var caisse = null

        let caisseId = null
        if (context.route.length === 2) {
            caisseId = context.route[1]
        } else if (config["page.don.mainCaisse"]) {
            caisseId = config["page.don.mainCaisse"]
        }

        if (!["DON", "CAGNOTTE"].includes(context.page.id)) {
            caisseId = context.page.id
        }

        if (caisseId) {
            caisse = applyI18n(this.getCaisse(caisseId), context)

            logger.debug({ caisse }, "caisse")

            title = caisse.name
            description = caisse.description

            if (caisse.bgimage) {
                bgImage = caisse.bgimage
            }

            content = null
            if (caisse.textContent) {
                content = caisse.textContent
            }

            youtube = null
            if (caisse.youtubeId) {
                youtube = caisse.youtubeId
            }

            carousel = caisse.imagesCaroussel

            metaTitle = caisse.metaTitle || title
            metaDescription = caisse.metaDescription || description
            metaImage = caisse.metaImage ? ASSET_URL + caisse.metaImage : null
        }

        if (caisse && (!caisse.active || caisse.paused)) {
            return (
                <div>
                    <Meta context={context} seo={caisse} title={metaTitle} description={metaDescription} image={metaImage}/>
                    <Header context={context}/>
                    <div style={{minHeight: "50vh", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <Result
                            style={{maxWidth: 600}}
                            status={"warning"}
                            title={t`Cette cagnotte est expiré !`}
                            subTitle={t`Vous ne pouvez pas utiliser cette cagnotte pour le moment, pour toute question contactez directement votre responsable.`}
                            extra={context.render !== "embed" ? (
                                <Button href={org.BASE_WEB_URL}>{t`Retourner à la page d'accueil`}</Button>
                            ) : undefined}
                        />
                    </div>
                    <Footer context={context}/>
                </div>
            )
        }

        if (caisse?.annualEventPage) return <>
            <Meta context={context} seo={caisse} title={metaTitle} description={metaDescription} image={metaImage || bgImage}/>
            <Header context={context}/>
            <AnnualEventFundraiser caisse={caisse} context={context}>
                <MultiDevise context={context} object={caisse} mode="modal"/>
                <MultiDevise context={context} object={caisse}/>
                <CardDon context={context} caisse={{...caisse, withObjectif: false, forceShowTotal: false}}/>
            </AnnualEventFundraiser>
            <Footer context={context}/>
        </>;

        return (
            <div>
                <Meta context={context} seo={caisse} title={metaTitle} description={metaDescription} image={metaImage}/>
                <Header context={context}/>

                <MultiDevise context={context} object={caisse} force={!caisse} mode="modal"/>
                <MultiDevise context={context} object={caisse} force={!caisse}/>

                <div style={{position: "relative"}}>

                    {bgImage && !context.isMobile && (
                        <div style={{position: "absolute", zIndex: 0, width: "100%", height: 400, marginTop: -20}}>
                            <div style={{
                                position: "absolute",
                                top: 0,
                                right: 0,
                                bottom: 0,
                                left: 0,
                                zIndex: 1,
                                backgroundColor: "rgba(0,0,0,0.5)"
                            }}/>
                            <img src={ASSET_URL + bgImage}
                                 style={{height: "inherit", width: "100%", objectFit: "cover"}}/>
                        </div>
                    )}

                    <div className="container" style={{
                        position: "relative",
                        zIndex: 10,
                        paddingBottom: "10%",
                        marginTop: 20
                    }}>

                        <Row justify={"space-between"}>

                            <Col xs={24} sm={24} md={13}>
                                {youtube && (
                                    <iframe
                                        src={`https://www.youtube.com/embed/${youtube}?autoplay=1&mute=1&loop=1&playlist=${youtube}`}
                                        style={{border: 0, height: 420, width: 720, maxWidth: "100%"}}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen/>
                                )}

                                <div className="col-12 d-md-none mb-20">
                                    <CardDon context={context} caisse={caisse}/>
                                </div>

                                {caisse?.aiContentBlockId && (
                                    <AiContentSlot
                                        blockId={caisse.aiContentBlockId}
                                        lang={context.lang?.value || context.lang}
                                    />
                                )}

                                {content && (
                                    <Card style={{
                                        marginTop: 0,
                                        boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                                    }}>
                                        <div dangerouslySetInnerHTML={{__html: content}} style={{width: "100%"}} />
                                    </Card>
                                )}

                                {Array.isArray(carousel) && (
                                    <Carousel
                                        autoPlay
                                        infiniteLoop
                                        showThumbs={false}
                                        showStatus={false}
                                        showArrows={false}
                                    >
                                        {carousel.map(i => {
                                            return (
                                                <img src={ASSET_URL + i} style={{height: 400, width: "100%", objectFit: "contain"}}/>
                                            )
                                        })}
                                    </Carousel>
                                )}

                            </Col>

                            <Col md={10} className="d-md-block d-none">
                                <CardDon context={context} caisse={caisse}/>
                            </Col>

                        </Row>
                    </div>
                </div>

                <Footer context={context}/>
            </div>
        )
    }
}
